/**
 * Application Configuration
 * Centralizes all editable configurations
 */

export default {
  // Number of available pollsters
  numPollsters: parseInt(import.meta.env.VITE_NUM_POLLSTERS) || 15,

  // Survey validations
  survey: {
    requireLocation: false, // GPS location required
    requireImage: false, // Photo required
  },

  // App configuration
  app: {
    name: "Consulting",
    version: "1.0.0",
    env: import.meta.env.VITE_ENV || "production",
  },

  // Notification settings
  notifications: {
    duration: 3000, // Duration in ms
    position: "top-right",
  },
};
